import { queryClient } from "@/core/caching/queryClient";
import { logoutStripeConnectSessions } from "@/core/session/stripeConnectSessions";

const STORAGE_KEY_NAME = "repeatmd-admin-app-auth-token";

export const setAuthToken = (token: string) => {
  queryClient.removeQueries({ queryKey: ["business-verification-submission"] });
  globalThis.localStorage.setItem(STORAGE_KEY_NAME, token);
};

export const getAuthToken = () => {
  return globalThis.localStorage.getItem(STORAGE_KEY_NAME);
};

export const isAuthorized = () => {
  return !!getAuthToken();
};

export const removeAuthToken = () => {
  globalThis.localStorage.removeItem(STORAGE_KEY_NAME);
  logoutStripeConnectSessions();
  queryClient.clear();
};
